{
  "id": "condition",
  "text": "UNIT_INTACT",
  "variant": "locked",
  "src": "/proof/video/condition.mp4",
  "poster": "/proof/video/condition-poster.jpg",
  "posterTime": 1.5,
  "duration": 6.0,
  "fps": 24.0,
  "keyframes": [
    {
      "t": 0.0,
      "top": 0.2296,
      "left": 0.1846,
      "width": 0.7269,
      "height": 0.6348
    },
    {
      "t": 0.5,
      "top": 0.2308,
      "left": 0.1856,
      "width": 0.7283,
      "height": 0.636
    },
    {
      "t": 1.0,
      "top": 0.2267,
      "left": 0.1659,
      "width": 0.738,
      "height": 0.6445
    },
    {
      "t": 1.5,
      "top": 0.2228,
      "left": 0.1207,
      "width": 0.7741,
      "height": 0.676
    },
    {
      "t": 2.0,
      "top": 0.2064,
      "left": 0.098,
      "width": 0.8104,
      "height": 0.7077
    },
    {
      "t": 2.5,
      "top": 0.1831,
      "left": 0.0348,
      "width": 0.9163,
      "height": 0.8002
    },
    {
      "t": 3.0,
      "top": 0.0805,
      "left": 0.0,
      "width": 1.0,
      "height": 0.9195
    },
    {
      "t": 3.5,
      "top": 0.0,
      "left": 0.0,
      "width": 1.0,
      "height": 1.0
    },
    {
      "t": 4.0,
      "top": 0.0,
      "left": 0.0,
      "width": 1.0,
      "height": 1.0
    },
    {
      "t": 4.5,
      "top": 0.0,
      "left": 0.0,
      "width": 1.0,
      "height": 1.0
    },
    {
      "t": 5.0,
      "top": 0.0,
      "left": 0.0,
      "width": 1.0,
      "height": 1.0
    },
    {
      "t": 5.5,
      "top": 0.0,
      "left": 0.0,
      "width": 1.0,
      "height": 1.0
    },
    {
      "t": 5.958,
      "top": 0.0,
      "left": 0.0,
      "width": 1.0,
      "height": 1.0
    }
  ]
}
